import gql from 'graphql-tag';
import { CREDIT_SUBMISSION_DECISION_FRAGMENT } from './fragments';

export const CREDIT_SUBMISSION_DECISION = gql`
  ${CREDIT_SUBMISSION_DECISION_FRAGMENT}
  query CreditSubmissionDecision($id: ID!) {
    creditSubmissionDecision {
      result: decision(decisionId: $id) {
        error
        success
        entity {
          ...CreditSubmissionDecisionFields
        }
      }
    }
  }
`;
